import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=469deeaf&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"
import style0 from "../../Style/info.scss?vue&type=style&index=0&id=469deeaf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469deeaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('469deeaf')) {
      api.createRecord('469deeaf', component.options)
    } else {
      api.reload('469deeaf', component.options)
    }
    module.hot.accept("./Info.vue?vue&type=template&id=469deeaf&scoped=true&", function () {
      api.rerender('469deeaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/ChangeInfo/Info.vue"
export default component.exports